$(function () {
    const table = $('#stock-item-units-table');
    if (!table.length) return;
    const statuses = $('#stock-item-unit-statuses');
    const dataTable = table.DataTable({ processing: true, serverSide: true, pageLength: 25, searchDelay: 350, ajax: { url: table.data('url'), data: function (data) { data.statuses = statuses.val() || []; } }, columns: [{ data: 'unit', name: 'id' }, { data: 'status', name: 'current_status' }, { data: 'warranty', name: 'warranty_until' }], language: window.dataTablesRussianLanguage });
    statuses.on('changed.bs.select change', function () { dataTable.page('first').draw(); });
});
